export enum DoctorProfileStatus {
  Pending = 'Pending',
  DOCTOR_NOT_ONBOARDED = 'DOCTOR_NOT_ONBOARDED',
  ACTIVE = 'ACTIVE',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Suspended = 'Suspended',
}
